import { Chain } from '@1delta/chain-registry'

export const query = (
  first: number,
  skip: number,
  chainId: string,
  includeUnlisted = false,
) => `
query GetMarkets {
  markets(first: ${first}, skip: ${skip}, where:  {
     chainId_in: [${chainId}]${includeUnlisted ? '' : ',\n     listed: true'}
  },
  orderBy: SupplyAssetsUsd,
  orderDirection: Desc
  ) {
    items {
      uniqueKey: marketId
      irmAddress
      oracleAddress
      lltv
      whitelisted: listed
      loanAsset {
        address
        name
        symbol
        decimals
        priceUsd
      }
      collateralAsset {
        address
        name
        symbol
        decimals
        priceUsd
      }
      state {
        borrowApy
        supplyApy
        price
        rewards {
           asset {
            address
          }
          supplyApr
          borrowApr
        }
        borrowAssets
        borrowAssetsUsd
        borrowShares
        supplyAssets
        supplyAssetsUsd
        supplyShares
        collateralAssets
        collateralAssetsUsd
        fee
        rateAtTarget
      }
    }
  }
}
`

const BASE_URL = 'https://blue-api.morpho.org/graphql'

function assertNoGraphQLErrors(json: any) {
  if (json?.errors?.length) {
    throw new Error(
      `Morpho markets API GraphQL error: ${json.errors
        .map((e: any) => e?.message)
        .join('; ')}`,
    )
  }
}

export async function fetchMorphoMarkets(
  chainId: string,
  includeUnlisted = false,
) {
  if (chainId !== Chain.ETHEREUM_MAINNET) {
    const requestBody = {
      query: query(200, 0, chainId, includeUnlisted),
      variables: {},
    }
    const response = await fetch(BASE_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    })

    if (!response.ok) {
      throw new Error(
        `Network error: ${response.status} - ${response.statusText}`,
      )
    }

    const data: any = await response.json()
    assertNoGraphQLErrors(data)

    return data.data
  }

  const requestBody0 = {
    query: query(200, 0, chainId, includeUnlisted),
    variables: {},
  }

  const requestBody1 = {
    query: query(200, 200, chainId, includeUnlisted),
    variables: {},
  }
  const [data0, data1] = await Promise.all([
    fetch(BASE_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody0),
    }).then((x) => x.json()),
    fetch(BASE_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody1),
    }).then((x) => x.json()),
  ])
  assertNoGraphQLErrors(data0)
  assertNoGraphQLErrors(data1)

  return {
    markets: {
      items: [...data0.data.markets.items, ...data1.data.markets.items],
    },
  }
}
